<template>
  <BaseModal :width="600" title="创建相册" v-model="show">
    <AlbumForm @saved="saved"/>
  </BaseModal>
</template>

<script>
import AlbumForm from "./AlbumForm";
import BaseModal from "../../../../comps/BaseModal";

export default {
  name: "AlbumCreate",
  components: {BaseModal, AlbumForm},
  data() {
    return {
      show: false,
    }
  },
  methods: {
    open() {
      this.show = true;
    },
    saved(res) {
      this.show = false;
      this.$emit("saved", res);
    }
  }
}
</script>

<style scoped>

</style>
